import type { NuxtApp } from '#app';

export default defineNuxtPlugin({
  name: 'voucher',
  parallel: true,
  async setup(_nuxtApp) {
    const { $router, $pinia } = _nuxtApp as NuxtApp;
    const cartStore = useCartStore($pinia);

    $router.afterEach(cartStore.handleVoucherFromQuery);
  },
});
